import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {select} from '@ngrx/store';

@Component({
    selector: 'app-hinweis-meldung',
    templateUrl: './hinweis-meldung.page.html'
})
export class HinweisMeldungPage implements OnInit {
    @Input() titel: string;
    @Input() subtitel: string;
    @Input() description: string;
    @Input() buttonOkText: string;

    private aiName = 'HinweisMeldungPage';

    constructor(private modalCtrl: ModalController) {
    }

    ngOnInit() {
    }

    ionViewDidLoad() {
    }


    async ok() {
        await this.modalCtrl.dismiss('ok');
    }

    async abbrechen() {
        await this.modalCtrl.dismiss();
    }

}
